export const deleteItem = `mutation($model : DeleteItemRequest!){
    deleteItem(input : $model)
  }`
